import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { CallbackEvent } from "@shopify/polaris-types";

export type ActiveSecurityTab = "blocking" | "otp";

type SIconType = React.JSX.IntrinsicElements["s-icon"]["type"];

const TABS: {
  id: ActiveSecurityTab;
  label: string;
  icon: SIconType;
  to: string;
}[] = [
  {
    id: "blocking",
    label: "Bloqueo de Usuario",
    icon: "lock",
    to: "/security-editor",
  },
  {
    id: "otp",
    label: "Verificación OTP",
    icon: "phone",
    to: "/security-editor/otp",
  },
];

function useActiveTab(): ActiveSecurityTab {
  const location = useLocation();
  if (location.pathname.startsWith("/security-editor/otp")) return "otp";
  return "blocking";
}

export function SecurityTabBar() {
  const active = useActiveTab();
  const navigate = useNavigate();

  const handleClick = (to: string, e: CallbackEvent<"s-clickable">) => {
    const mouseEvent = e as unknown as MouseEvent;
    // Let the browser handle modifier-click (open in new tab/window)
    if (
      mouseEvent.metaKey ||
      mouseEvent.ctrlKey ||
      mouseEvent.shiftKey ||
      mouseEvent.altKey
    ) {
      return;
    }
    e.preventDefault();
    navigate(to);
  };

  return (
    <nav className="flex items-center bg-white p-1 rounded-full shadow-sm border border-gray-200/50">
      {TABS.map((tab) => {
        const isActive = active === tab.id;
        return (
          <div key={tab.id} className="flex-1">
            <s-clickable
              href={tab.to}
              onClick={(e: CallbackEvent<"s-clickable">) =>
                handleClick(tab.to, e)
              }
              aria-current={isActive ? "page" : undefined}
              inlineSize="100%"
              borderRadius="large-200"
            >
              <span
                className={`flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-full transition-all ${
                  isActive
                    ? "bg-gray-100 text-gray-900 shadow-[0_1px_2px_rgba(0,0,0,0.05)]"
                    : "text-gray-500 hover:text-gray-700 hover:bg-gray-50"
                }`}
              >
                <s-icon type={tab.icon} />
                {tab.label}
              </span>
            </s-clickable>
          </div>
        );
      })}
    </nav>
  );
}
